import { MessageCentreThreadStoreStateType } from '../../Types/MessageCentreThreadStoreTypes';
import { MessageCentreThreadStoreActionsType } from '../../Types/MessageCentreThreadReducerTypes';

export default function MessageCentreThreadReducer(
	state: MessageCentreThreadStoreStateType,
	action: MessageCentreThreadStoreActionsType,
): MessageCentreThreadStoreStateType {
	switch (action.type) {
		case 'groupMessageData':
			return {
				...state,
				groupedMessageData: action.data,
			};
		case 'removeMessageAttachment':
			return {
				...state,
				messageAttachments: action.messageAttachments,
				attachmentsManagerOpen: action.messageAttachments.length !== 0,
			};
		case 'replyingToThread':
			return {
				...state,
				composerSendDisabled: true,
			};
		case 'replyToThreadComplete':
			return {
				...state,
				composerSendDisabled: false,
				composerOpen: false,
				messageContent: '',
				messageAttachments: null,
			};
		case 'toggleComposeContainer':
			return {
				...state,
				composerOpen: action.state,
			};
		case 'updateMessageValue':
			return {
				...state,
				messageContent: action.content,
				composerSendDisabled: action.content.length < 10,
			};
		case 'updateMessageAttachments':
			return {
				...state,
				attachmentsManagerOpen: action.attachmentsManagerOpen,
				messageAttachments: action.messageAttachments,
				attachmentSize: action.attachmentSize,
				attachmentSizeError: action.attachmentSizeError,
				attachmentCountError: action.attachmentCountError,
				composerSendDisabled: action.attachmentSizeError || action.attachmentCountError,
			};
		default:
			return state;
	}
}
